import ButtonScaleViewWithText, {
  ButtonScaleViewWithTextOpts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import { Tooltip, TooltipOpts } from './Tooltip';
import { getFlexNode } from '@play-co/timestep-core/flexbox';

type ButtonTooltipOpts = TooltipOpts & {
  /**
   * Options for the buttons inside the tooltip
   */
  buttons: Omit<ButtonScaleViewWithTextOpts, 'superview'>[];
};

/**
 * A tooltip wrapper that allows adding multiple buttons inside as the content.
 */
export class ButtonsTooltip extends Tooltip {
  private buttons: ButtonScaleViewWithText[] = [];

  constructor(opts: ButtonTooltipOpts) {
    super({
      ...opts,
      flex: {
        flexDirection: 'column',
        paddingHorizontal: 20,
        paddingTop: 18,
        paddingBottom: 11,
        ...opts.flex,
      },
    });

    for (let i = 0; i < opts.buttons.length; i++) {
      const buttonOpts = opts.buttons[i];
      const button = new ButtonScaleViewWithText({
        superview: this.content,
        ...uiConfig.buttons.secondary,
        width: 229,
        height: 70,
        labelOffsetX: -5,
        labelOffsetY: -1,
        font: 'Body',
        fontSize: 35,
        align: 'center',
        verticalAlign: 'center',
        ...buttonOpts,
      });
      getFlexNode(button).marginVertical = 6;
      this.buttons.push(button);
    }
  }

  public getButton(index: number) {
    return this.buttons[index];
  }
}
